import { createRef } from "react";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi
import Activity from "components/DigiHapi/Activity.js";

import { fetchGetAudits } from "actions/audit";

// Redux
import { useDispatch, useSelector } from "react-redux";

export default function AuditsPage(props) {
	const table = createRef();

	const dispatch = useDispatch();

	const {
		isFetchingList,
		audits: auditsParent,
		communities,
		users,
		totalPages
	} = useSelector(state => state.auditReducer);

	const audits = Object.values(auditsParent);

	const get2Chars = param => {
		return ("" + param).length === 1 ? "0" + param : param;
	};

	const formatDate = d => {
		const date = new Date(d);
		return `${get2Chars(date.getDate())}/${get2Chars(
			date.getMonth() + 1
		)}/${date.getFullYear()} ${get2Chars(date.getHours())}:${get2Chars(
			date.getMinutes()
		)}`;
	};

	const getAudits = () => {
		const result = audits.map(
			({ type, userId, communityId, dateAdded, appname }) => {
				return {
					dateAdded: formatDate(dateAdded),
					pseudo: users[userId] ? users[userId].pseudo : "",
					type,
					community:
						communities && communities[communityId]
							? communities[communityId].name
							: "",
					appname
				};
			}
		);
		return result;
	};

	return (
		<Grid container spacing={3} justifyContent="center">
			<Grid item xs={12}>
				<Card>
					<MDBox
						mx={2}
						mt={-3}
						py={2}
						px={2}
						variant="gradient"
						bgColor="primary"
						borderRadius="lg"
						coloredShadow="primary"
						display="flex"
						alignItems="center"
						color="white"
					>
						<Icon>list_alt</Icon>
						<MDTypography variant="h6" color="white" ml={1.5}>
							{"Traces d'audit"}
						</MDTypography>
					</MDBox>
					<MDBox p={2}>
						<DataTable
							ref={table}
							data={getAudits()}
							filterable
							columns={[
								{
									Header: "Application",
									accessor: "appname",
									sortable: true,
									filterable: false
								},
								{
									Header: "Date",
									accessor: "dateAdded",
									sortable: true,
									filterable: false
								},
								{
									Header: "Pseudo",
									accessor: "pseudo",
									sortable: false,
									filterable: false
								},
								{
									Header: "Type",
									accessor: "type",
									sortable: true,
									filterable: false
								},
								{
									Header: "Communauté",
									accessor: "community",
									sortable: false,
									filterable: false
								},
								{
									Header: "",
									accessor: "empty",
									sortable: false,
									filterable: false
								}
							]}
							loading={isFetchingList}
							defaultPageSize={20}
							manual
							showPaginationTop
							showPaginationBottom={false}
							previousText="Précédent"
							nextText="Suivant"
							rowsText="Lignes"
							noDataText={"Aucunes traces d'audit"}
							ofText="sur"
							loadingText="Chargement..."
							pages={totalPages}
							onFetchData={(state, instance) => {
								dispatch(fetchGetAudits(state));
							}}
						/>
					</MDBox>
					<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
						<MDButton
							variant="gradient"
							color="primary"
							onClick={() => dispatch(fetchGetAudits(table.current.state))}
							disabled={isFetchingList}
						>
							{isFetchingList ? <Activity /> : "Recharger"}
						</MDButton>
					</MDBox>
				</Card>
			</Grid>
		</Grid>
	);
}
